import { FormStore, GlobalStore } from "@roc/feature-app-core";
import { action, makeObservable } from "mobx";

const hoaForm = {
  fields: {
    annualFeeAmount: {
      value: 0,
      error: null,
      rule: 'required',
      message: 'Annual HOA fee amount is required.',
    },
  },
  meta: {
    isValid: false,
    error: null,
  },
};

export class HoaFormStore extends FormStore {
  constructor(globalStore: GlobalStore) {
    super({ ...hoaForm }, globalStore);
    makeObservable(this, {
      load: action,
    });
  }

  load(data: Record<string, any>) {
    this.loadForm(data);
  }
}
